const STOCK_LEVELS = {
  available: 'available',
  low: 'low',
  none: 'none',
  almostNone: 'almostNone',
};

export { STOCK_LEVELS };



// WEBPACK FOOTER //
// ./src/models/Stock.js